import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './en'
import pt from './pt'
import es from './es'
import dateTimeFormats from './dates'

Vue.use(VueI18n)

const localeByCountryCode = {
  BR: 'pt',
  SV: 'es',
  UY: 'es',
  HN: 'es',
  CL: 'es',
  PY: 'es',
  DO: 'es',
  MX: 'es',
  CO: 'es',
  BO: 'es',
  GT: 'es',
  CR: 'es',
  VE: 'es',
  AR: 'es',
  PE: 'es',
  NI: 'es',
  EC: 'es',
  US: 'en',
  FR: 'fr',
  PT: 'pt'
}

export { localeByCountryCode }

export default new VueI18n({
  fallbackLocale: 'en',
  dateTimeFormats,
  messages: { en, pt, es }
})
